module.exports = __webpack_public_path__ + "img/riointbig2.4089d3be.png";